export const flightClass: any = {
  economy: "エコノミー",
  economyStandard: "エコノミー",
  economyPremium: "エコノミープレミアム",
  business: "ビジネス",
  first: "ファースト",
};
